import React from 'react';

import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { RedirectSingleton, RedirectType } from '@pkg/classes';

import { useCheckUserGlobalRedirects } from '@app/routes/hooks';
import { AUTH_SIGN_IN } from '@app/routes/paths/auth';
import { useAuthTokens } from '@app/store/zustand/Auth/useUserTokens';

export const ProtectedRoute = () => {
    const isAuthenticated = useAuthTokens((state) => state.isAuthenticated);
    const redirectTo = useCheckUserGlobalRedirects();
    const { search, pathname } = useLocation();
    const hasPath = pathname?.length > 1;
    const fullPath = search ? `${pathname}${search}` : pathname;

    if (!isAuthenticated && hasPath) {
        RedirectSingleton.setRedirect(RedirectType.PostLogin, fullPath);
        return <Navigate to={AUTH_SIGN_IN} replace />;
    }

    return redirectTo ? <Navigate to={redirectTo} replace /> : <Outlet />;
};
